<template>
  <ul class="payment_icons" ref="payment_icons" :class="class_name" v-if="payIcon && payIcon.length">
    <!-- 加载完成再加上边框 -->
    <li
      class="payment_icons--item"
      v-for="item in payIcon"
      :class="{ 'payment_icons--loaded': item.loading_completed }"
      :key="item.id"
    >
      <img
        class="lazyload"
        :src="item.icon.url"
        @load="item.loading_completed = true"
        alt=""
      />
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    disable: {
      type: [Array],
      default: () => [],
    },
    wrapstyle: {
      type: [Object],
      default: () => {},
    },
    class_name: {
      type: String,
    },
  },
  data() {
    return {
      payIcon: [],
    }
  },
  beforeMount() {
    this.$axios.get('/api/store/custom_payment_icon').then((res) => {
      let { data } = res.data
      if (data && data.length) {
        this.payIcon = []
        data.forEach((item) => {
          if (!this.disable.includes(item.title.toLocaleLowerCase())) {
            this.payIcon.push({ ...item, loading_completed: false })
          }
        })
      }
    })
  },
}
</script>
<style  lang='scss'>
.payment_icons {
  list-style: none;
  margin: 0;
  padding: 0;
  .payment_icons--loaded {
    img {
      border: 1px solid #eee;
    }
  }
  .payment_icons--item {
    display: inline-block;
    border-radius: 3px;
    margin-right: 12px;
    img {
      max-width: 42px;
      max-height: 27px;
    }
  }
  [src*='svg'] {
    width: 42px;
    height: 27px;
  }
}
.payment_style {
  margin: -4px 0 0 30px;
  .payment_icons--item {
    margin-top: 4px;
    margin-right: 4px;
  }
}
.vogue-foot-pay {
  li:not(:last-child) {
    margin-right: 12px;
  }
}
</style>